export default {
    REQUEST_CANCELLED: "api/cancellation-exception",
    ACCESS_TOKEN_EXPIRED: "api/access-token-expired"
}